import { render, staticRenderFns } from "./BadgeNew.vue?vue&type=template&id=2e5cc73e&scoped=true"
import script from "./BadgeNew.vue?vue&type=script&lang=ts"
export * from "./BadgeNew.vue?vue&type=script&lang=ts"
import style0 from "./BadgeNew.vue?vue&type=style&index=0&id=2e5cc73e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5cc73e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5cc73e')) {
      api.createRecord('2e5cc73e', component.options)
    } else {
      api.reload('2e5cc73e', component.options)
    }
    module.hot.accept("./BadgeNew.vue?vue&type=template&id=2e5cc73e&scoped=true", function () {
      api.rerender('2e5cc73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BadgeNew.vue"
export default component.exports